/**
 * 日付ユーティリティ
 * 日付に関する共通処理を提供する
 */

/**
 * 現在の日付を日本時間のYYYY-MM-DD形式で取得
 * @returns 日付文字列（例: "2024-01-15"）
 */
export const getJapanDateString = (): string => {
  const now = new Date();

  // 現在のタイムゾーンで日付を取得
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

/**
 * Date型を日本時間のYYYY-MM-DD形式に変換
 * @param date - Date型の日付
 * @returns 日付文字列（例: "2024-01-15"）
 */
export const formatDateToString = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

/**
 * YYYY-MM-DD形式の文字列をDate型に変換
 * @param dateString - 日付文字列（例: "2024-01-15"）
 * @returns Date型
 */
export const parseStringToDate = (dateString: string): Date => {
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
};
